import styled from '@emotion/styled'
import { colors } from '@mobi/component-library/Foundations'

export const DiagnosticsContainerStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  borderTop: `2px solid ${colors.warning[700]}`,
  marginTop: '4rem',
  paddingTop: '2rem',
  marginBottom: '1rem',
  marginLeft: '0.5rem',
  marginRight: '0.5rem',
})

export const OverviewStyled = styled.div({
  display: 'flex',
  flexDirection: 'row',
  marginBottom: '1rem',
})

export const StatisticsStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
})

export const StatisticsRowStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

export const TableStyled = styled.div({
  overflow: 'scroll',
  marginTop: '5px',
  marginLeft: '5px',
})
export const RowStyled = styled.div<{ backgroundShade: string }>(
  {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    width: 'fit-content',
  },
  ({ backgroundShade }) => ({
    background:
      backgroundShade == 'dark'
        ? '#f8f8f8'
        : backgroundShade == 'error'
          ? '#fee'
          : backgroundShade == 'inside'
            ? '#c7f2d0'
            : '#ffffff',
  })
)
export const CellIndexStyled = styled.div({
  minWidth: '2em',
})
export const CellLatLonStyled = styled.div({
  minWidth: '11em',
})
export const CellAccuracyStyled = styled.div({
  minWidth: '5em',
})
export const CellDeltaStyled = styled.div({
  textAlign: 'center',
  minWidth: '4em',
})
export const CellMockedStyled = styled.div({
  minWidth: '5em',
})
export const CellPreciseAccuracyStyled = styled.div({
  minWidth: '5em',
})
export const CellTimeStyled = styled.div({
  minWidth: '10em',
})

export const CellInsideStyled = styled.div({
  minWidth: '5em',
})
export const CellDistanceStyled = styled.div({
  minWidth: '5em',
})
export const CellVenueLocationStyled = styled.div({
  minWidth: '10em',
})

export const CellVenueNameStyled = styled.div({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '20em',
  minWidth: '20em',
  width: '20em',
})
export const CellErrorStyled = styled.div({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  minWidth: '10em',
})

export const ButtonContainerStyled = styled.div({
  display: 'flex',
  gap: '1rem',
})
